import { Url } from '@wix/da-url';
import { getDeviationType, getPrimaryTier, isDeviationAuthor } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { usePrimaryTier } from '../../Tier/PrimaryTierContext';
import { useCurrentUser } from './useCurrentUser';
/** returns member subscription info for the given deviation */ export function useSubscriptionTier(deviation) {
    const currentUser = useCurrentUser();
    const isOwner = deviation ? isDeviationAuthor(deviation, currentUser) : false;
    const contextualTier = usePrimaryTier();
    const { isTier, isInTier, tier, isUserSubscribed, tierCheckoutUrl, subscriptionsTabUrl, needsSubscription, isSubscribedButBlocked } = getBasicTierSubscriptionInfo(deviation, contextualTier);
    // you are never blocked if
    // - you're the content's owner,
    // - there's no subscription needed
    const subscriptionsMatter = !isOwner && !isTier;
    return {
        isTier,
        isInTier,
        tier,
        isOwner,
        isUserSubscribed,
        tierCheckoutUrl,
        subscriptionsTabUrl,
        needsSubscription: subscriptionsMatter && needsSubscription,
        isSubscribedButBlocked: subscriptionsMatter && isSubscribedButBlocked
    };
}
/**
 * Get the basic tier info without react dependency
 */ export function getBasicTierSubscriptionInfo(deviation, contextualTier) {
    var _deviation_tier, _primaryTierFromDeviation_tier, _tier_tier;
    const primaryTierFromDeviation = deviation && getPrimaryTier(deviation);
    const primaryTier = contextualTier || primaryTierFromDeviation;
    const isTier = deviation ? getDeviationType(deviation) === DeviationTypes.TIER : false;
    const isInTier = !!primaryTier;
    const tier = isTier ? deviation : primaryTier;
    const isUserSubscribed = isTier ? !!(deviation === null || deviation === void 0 ? void 0 : (_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.isUserSubscribed) : !!(primaryTierFromDeviation === null || primaryTierFromDeviation === void 0 ? void 0 : (_primaryTierFromDeviation_tier = primaryTierFromDeviation.tier) === null || _primaryTierFromDeviation_tier === void 0 ? void 0 : _primaryTierFromDeviation_tier.isUserSubscribed);
    const tierCheckoutUrl = (tier === null || tier === void 0 ? void 0 : (_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.subproductId) ? Url.checkoutLink(tier.tier.subproductId) : undefined;
    const subscriptionsTabUrl = (tier === null || tier === void 0 ? void 0 : tier.author) ? Url.userLink(tier.author.username, '/subscriptions') : undefined;
    const needsSubscription = !!tier && !isUserSubscribed;
    const isSubscribedButBlocked = (deviation === null || deviation === void 0 ? void 0 : deviation.tierAccess) === 'locked-subscribed';
    return {
        isTier,
        isInTier,
        tier,
        isUserSubscribed: isUserSubscribed,
        tierCheckoutUrl,
        subscriptionsTabUrl,
        needsSubscription,
        isSubscribedButBlocked
    };
}
